import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  elevation?: 'none' | 'low' | 'medium' | 'high' | 'elegant';
  hover?: boolean;
  background?: 'white' | 'light' | 'primary' | 'secondary' | 'dark';
}

const Card = ({
  children,
  className = '',
  elevation = 'medium',
  hover = true,
  background = 'white'
}: CardProps) => {
  // Shadow variations
  const elevations: Record<NonNullable<CardProps['elevation']>, string> = {
    none: '',
    low: 'shadow-sm',
    medium: 'shadow-md',
    high: 'shadow-lg',
    elegant: 'shadow-elegant'
  };

  // Background colors
  const backgrounds: Record<NonNullable<CardProps['background']>, string> = {
    white: 'bg-white',
    light: 'bg-gray-50',
    primary: 'bg-primary text-white',
    secondary: 'bg-secondary text-white',
    dark: 'bg-gray-800 text-white'
  };

  // Base classes for the card
  const baseClasses = `rounded-lg overflow-hidden ${elevations[elevation]} ${backgrounds[background]}`;

  // Combined classes
  const cardClasses = `${baseClasses} ${className}`;

  return (
    <motion.div
      className={cardClasses}
      whileHover={hover ? { y: -5, boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)' } : {}}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

export default Card;
